import { chakra } from '@chakra-ui/react';

var CheckboxControl = /*#__PURE__*/chakra('span', {
  baseStyle: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    verticalAlign: 'top',
    userSelect: 'none',
    flexShrink: 0
  }
});

export { CheckboxControl };
//# sourceMappingURL=CheckboxControl.js.map
